export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const loginAction = () => {
  return { type: LOGIN };
};

export const logoutAction = () => {
  localStorage.removeItem('X-Auth-Token');
  return { type: LOGOUT };
};
